import React, { forwardRef, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import InsightForm from './contents/insightForm';
import InsightList from './contents/insightListAndDetail';
import InsightDetail from './contents/insightDetail';
import PrincipleForm from './contents/principleForm';

import { insightModals, INSIGHT_FIELDS } from '@model';

import Modal from './insightModalPortal';

const COMPS = {
  [insightModals.INSIGHT_LIST]: InsightList,
  [insightModals.INSIGHT_FORM]: InsightForm,
  [insightModals.G_PRINCIPLES_FORM]: PrincipleForm,
  [insightModals.INSIGHT_DETAIL]: InsightList,
  [insightModals.G_PRINCIPLE_DETAIL]: InsightDetail,
};

const InsightModal = forwardRef((props, ref) => {
  const [config, setConfig] = useState({});
  const [isFetchLoading, toggleFetchLoading] = useState(false);
  const [isActionLoading, toggleActionLoading] = useState(false);
  const changeConfig = (config) => {
    setConfig(config);
  };

  const _config = {
    field: INSIGHT_FIELDS.ANALYSIS,
    ...props,
    ...config,
    toggleFetchLoading,
    isFetchLoading,
    isActionLoading,
    toggleActionLoading,
  };

  const { type = insightModals.INSIGHT_FORM } = _config;

  const Child = useMemo(() => COMPS[type], [type]);

  return (
    <Modal {..._config} ref={ref} changeConfig={changeConfig}>
      {Child && <Child />}
    </Modal>
  );
});

InsightModal.defaultProps = {
  rootNode: '.leftContent',
  disableScroll: false,
};

InsightModal.propTypes = { rootNode: PropTypes.string };

export default InsightModal;
